const AOS = require("aos");
const $ = require("jquery");
window.jQuery = $;

require("bootstrap");
require("slick-carousel");
require("magnific-popup");
require("hamburgers");

$(document).ready(function () {
  // Add class on scroll
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();

    if (scroll >= 50) {
      $(".navbar-custom").addClass("scroll");
      $(".btn-floating").addClass("active");
      $(".search-bar").addClass("scroll");
    } else {
      $(".navbar-custom").removeClass("scroll");
      $(".btn-floating").removeClass("active");
      $(".search-bar").removeClass("scroll");
    }
  });

  $("button.search").on("click", function (e) {
    $(".search-bar").toggleClass("active"); //you can list several class names
    $(".search-bar input").focus(); //you can list several class names
    e.preventDefault();
  });

  $(".btn-team").on("click", function (e) {
    $(".team-details").toggleClass("active"); //you can list several class names
    $(this).toggleClass("active"); //you can list several class names
    e.preventDefault();
  });

  $("button.hamburger").on("click", function (e) {
    $(".navbar-mobile").toggleClass("active"); //you can list several class names
    $(this).addClass("is-active"); //you can list several class names
    e.preventDefault();
  });

  $("button.btn-floating").on("click", function (e) {
    $("#contact-form-floating").addClass("active"); //you can list several class names
    e.preventDefault();
  });

  $("button.close-btn").on("click", function (e) {
    $("#contact-form-floating").removeClass("active"); //you can list several class names
    e.preventDefault();
  });

  // Enable tooltips everywhere
  $(function () {
    $('[data-toggle="tooltip"]').tooltip();
  });

  $(".carousel-team").slick({
    dots: false,
    infinite: true,
    arrows: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    prevArrow:
      '<button class="slick-arrow slick-prev bg-quinary"><i class="fal fa-long-arrow-left"></i></button>',
    nextArrow:
      '<button class="slick-arrow slick-next bg-quinary"><i class="fal fa-long-arrow-right"></i></button>',
    responsive: [
      {
        breakpoint: 1430,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1020,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 760,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".client-logos-carousel").on("init", function (event, slick) {
    console.log(slick);
    let window_width = $(window).width();
    if (window_width > 1199) {
      if (slick.slideCount > 5) {
        $(this).addClass("pad-bottom");
      }
    } else if (window_width > 991) {
      if (slick.slideCount > 4) {
        $(this).addClass("pad-bottom");
      }
    } else if (window_width > 768) {
      if (slick.slideCount > 3) {
        $(this).addClass("pad-bottom");
      }
    } else {
      if (slick.slideCount > 2) {
        $(this).addClass("pad-bottom");
      }
    }
  });

  $(".client-logos-carousel").slick({
    arrows: true,
    autoplay: false,
    autoplaySpeed: 5000,
    dots: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 991,
        settings: {
          autoplay: true,
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
    slidesToShow: 2,
    slidesToScroll: 1,
    prevArrow:
      '<button class="slick-arrow slick-prev bg-quinary"><i class="fal fa-long-arrow-left"></i></button>',
    nextArrow:
      '<button class="slick-arrow slick-next bg-quinary"><i class="fal fa-long-arrow-right"></i></button>',
  });

  // $(".home-service-carousel").slick({
  //   arrows: false,
  //   autoplay: true,
  //   autoplaySpeed: 6500,
  //   dots: true,
  //   slidesToScroll: 1,
  //   slidesToShow: 1,
  // });

  $(".carousel-what").slick({
    dots: false,
    infinite: true,
    arrows: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    prevArrow:
      '<button class="slick-arrow slick-prev bg-quinary"><i class="fal fa-long-arrow-left"></i></button>',
    nextArrow:
      '<button class="slick-arrow slick-next bg-quinary"><i class="fal fa-long-arrow-right"></i></button>',
    responsive: [
      {
        breakpoint: 1400,
        settings: "unslick",
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 3,
        },
      },
    ],
  });

  $(".carousel-how").slick({
    dots: false,
    infinite: true,
    arrows: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    prevArrow:
      '<button class="slick-arrow slick-prev bg-quinary"><i class="fal fa-long-arrow-left"></i></button>',
    nextArrow:
      '<button class="slick-arrow slick-next bg-quinary"><i class="fal fa-long-arrow-right"></i></button>',
    responsive: [
      {
        breakpoint: 1400,
        settings: "unslick",
      },
      {
        breakpoint: 1020,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 3,
        },
      },
    ],
  });

  $(".carousel-case-gallery").slick({
    dots: false,
    infinite: true,
    arrows: false,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    mobileFirst: true,
    prevArrow:
      '<button class="slick-arrow slick-prev bg-quinary"><i class="fal fa-long-arrow-left"></i></button>',
    nextArrow:
      '<button class="slick-arrow slick-next bg-quinary"><i class="fal fa-long-arrow-right"></i></button>',
    responsive: [
      {
        breakpoint: 1900,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".image-popup-vertical-fit").magnificPopup({
    type: "image",
    closeOnContentClick: true,
    mainClass: "mfp-img-mobile",
    image: {
      verticalFit: true,
    },
  });

  $(".results-carousel").slick({
    dots: true,
    infinite: true,
    arrows: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    prevArrow:
      '<button class="slick-arrow slick-prev bg-quinary"><i class="fal fa-long-arrow-left"></i></button>',
    nextArrow:
      '<button class="slick-arrow slick-next bg-quinary"><i class="fal fa-long-arrow-right"></i></button>',
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          arrows: true,
          dots: false,
        },
      },
    ],
  });

  $(".carousel-gallery").slick({
    dots: false,
    infinite: true,
    arrows: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    fade: true,
    prevArrow:
      '<button class="slick-arrow slick-prev bg-quinary"><i class="fal fa-long-arrow-left"></i></button>',
    nextArrow:
      '<button class="slick-arrow slick-next bg-quinary"><i class="fal fa-long-arrow-right"></i></button>',
  });

  // $('.button-wrapper > .slick-next').click(function(){ $('.carousel-gallery').slick('slickNext'); });
  // $('.button-wrapper > .slick-prev').click(function(){ $('.carousel-gallery').slick('slickPrev'); });

  $(".carousel-services").slick({
    dots: false,
    infinite: true,
    arrows: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    prevArrow:
      '<button class="slick-arrow slick-prev bg-quinary"><i class="fal fa-long-arrow-left"></i></button>',
    nextArrow:
      '<button class="slick-arrow slick-next bg-quinary"><i class="fal fa-long-arrow-right"></i></button>',
    responsive: [
      {
        breakpoint: 1900,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1020,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".testimonials-carousel").slick({
    dots: true,
    autoplay: true,
    infinite: true,
    fade: true,
    arrows: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
  });

  $(".carousel-case-studies").slick({
    dots: false,
    infinite: true,
    arrows: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    prevArrow:
      '<button class="slick-arrow slick-prev bg-quinary"><i class="fal fa-long-arrow-left"></i></button>',
    nextArrow:
      '<button class="slick-arrow slick-next bg-quinary"><i class="fal fa-long-arrow-right"></i></button>',
    responsive: [
      {
        breakpoint: 1900,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $("#page-navi a").on("click", function (event) {
    if (this.hash !== "") {
      event.preventDefault();
      var hash = this.hash;

      $("html, body").animate(
        {
          scrollTop: $(hash).offset().top,
        },
        800,
        function () {
          window.location.hash = hash;
        }
      );
    }
  });

  // AOS.
  AOS.init();
});

// Google Maps.
(function ($) {
  function new_map($el) {
    var $markers = $el.find(".marker");
    var args = {
      center: new google.maps.LatLng(0, 0),
      mapTypeId: google.maps.MapTypeId.SATELLITE,
      styles: [
        {
          featureType: "administrative.land_parcel",
          elementType: "labels",
          stylers: [{ visibility: "off" }],
        },
        {
          featureType: "poi",
          elementType: "labels.text",
          stylers: [{ visibility: "off" }],
        },
        { featureType: "poi.business", stylers: [{ visibility: "off" }] },
        {
          featureType: "road",
          elementType: "labels.icon",
          stylers: [{ visibility: "off" }],
        },
        {
          featureType: "road.local",
          elementType: "labels",
          stylers: [{ visibility: "off" }],
        },
        { featureType: "transit", stylers: [{ visibility: "off" }] },
      ],
      zoom: 16,
    };
    var map = new google.maps.Map($el[0], args);
    map.markers = [];
    $markers.each(function () {
      add_marker($(this), map);
    });
    center_map(map);
    return map;
  }

  function add_marker($marker, map) {
    var latlng = new google.maps.LatLng(
      $marker.attr("data-lat"),
      $marker.attr("data-lng")
    );
    var icon = {
      url: "" + $marker.attr("data-icon") + "",
      scaledSize: new google.maps.Size(46, 46),
    };
    var marker = new google.maps.Marker({
      icon: icon,
      map: map,
      position: latlng,
    });
    map.markers.push(marker);
    if ($marker.html()) {
      var infowindow = new google.maps.InfoWindow({
        content: $marker.html(),
      });
      google.maps.event.addListener(marker, "click", function () {
        infowindow.open(map, marker);
      });
    }
  }

  function center_map(map) {
    var bounds = new google.maps.LatLngBounds();
    $.each(map.markers, function (i, marker) {
      var latlng = new google.maps.LatLng(
        marker.position.lat(),
        marker.position.lng()
      );
      bounds.extend(latlng);
    });
    if (map.markers.length == 1) {
      map.setCenter(bounds.getCenter());
      map.setZoom(16);
    } else {
      map.fitBounds(bounds);
    }
  }

  var map = null;
  $(document).ready(function () {
    $(".map").each(function () {
      map = new_map($(this));
    });
  });
})($);
